import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "experience.title") separator=" | "}}

  {{! Page Header }}
  <section class="page-header" aria-labelledby="experience-title">
    <div class="container">
      <div class="section-header">
        <h1 id="experience-title" class="section-header__title">{{t
            "experience.title"
          }}</h1>
        <p class="section-header__description">
          {{t "experience.subtitle"}}
        </p>
      </div>
    </div>
  </section>

  {{! Professional Experience Timeline }}
  <section class="section" aria-labelledby="work-experience-title">
    <div class="container">
      <h2 id="work-experience-title" class="sr-only">{{t
          "experience.work_experience"
        }}</h2>

      <div class="timeline" role="list" aria-label="Career timeline">
        {{! Freelance Consultant }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2020-12">December 2020</time>
            –
            {{t "experience.present"}}
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.freelance.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t "experience.freelance.company"}}</span>
          </div>
          <div class="timeline__description" property="description">
            <p>{{t "experience.freelance.intro"}}</p>
            <ul>
              <li>
                <strong>{{t "experience.freelance.lblod"}}</strong>
                {{t "experience.freelance.lblod_desc"}}
              </li>
              <li>{{t "experience.freelance.modeling"}}</li>
              <li>{{t "experience.freelance.lod"}}</li>
            </ul>
          </div>
        </article>

        {{! IQVIA }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2019-06">June 2019</time>
            –
            <time property="endDate" datetime="2020-10">October 2020</time>
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.iqvia.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t "experience.iqvia.company"}}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.iqvia.forcea"}}</li>
              <li>{{t "experience.iqvia.bi"}}</li>
              <li>{{t "experience.iqvia.partnerships"}}</li>
            </ul>
          </div>
        </article>

        {{! Colruyt Group }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2018-06">June 2018</time>
            –
            <time property="endDate" datetime="2019-05">May 2019</time>
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.colruyt.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t "experience.colruyt.company"}}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.colruyt.operational"}}</li>
              <li>{{t "experience.colruyt.team"}}</li>
            </ul>
          </div>
        </article>

        {{! Agfa HealthCare }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2010-01">January 2010</time>
            –
            <time property="endDate" datetime="2018-02">February 2018</time>
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.agfa.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t "experience.agfa.company"}}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.agfa.engineer"}}</li>
              <li>{{t "experience.agfa.ci"}}</li>
              <li>{{t "experience.agfa.research"}}</li>
              <li>{{t "experience.agfa.pm"}}</li>
              <li>{{t "experience.agfa.jump"}}</li>
              <li>{{t "experience.agfa.security"}}</li>
              <li>{{t "experience.agfa.agfapolis"}}</li>
            </ul>
          </div>
        </article>

        {{! Amnesty Board Member }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2013-04">April 2013</time>
            –
            <time property="endDate" datetime="2017-04">April 2017</time>
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.amnesty_board.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t
                "experience.amnesty_board.company"
              }}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.amnesty_board.growth"}}</li>
              <li>{{t "experience.amnesty_board.governance"}}</li>
              <li>{{t "experience.amnesty_board.org"}}</li>
            </ul>
          </div>
        </article>

        {{! Amnesty Expert }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2010-10">October 2010</time>
            –
            <time property="endDate" datetime="2015-09">September 2015</time>
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.amnesty_expert.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t
                "experience.amnesty_expert.company"
              }}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.amnesty_expert.expert"}}</li>
              <li>{{t "experience.amnesty_expert.campaign"}}</li>
              <li>{{t "experience.amnesty_expert.coarm"}}</li>
              <li>{{t "experience.amnesty_expert.decree"}}</li>
            </ul>
          </div>
        </article>

        {{! Callataÿ and Wouters }}
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="OrganizationRole"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <div class="timeline__date">
            <time property="startDate" datetime="2009-10">October 2009</time>
            –
            <time property="endDate" datetime="2010-01">January 2010</time>
          </div>
          <h3 class="timeline__title" property="roleName">{{t
              "experience.callatay.title"
            }}</h3>
          <div
            class="timeline__company"
            property="memberOf"
            typeof="Organization"
          >
            <span property="name">{{t "experience.callatay.company"}}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.callatay.banking"}}</li>
            </ul>
          </div>
        </article>
      </div>

      <div class="card card--bordered mt-8">
        <p class="mb-0">
          {{t "experience.linkedin_cta"}}
          <a
            href="https://www.linkedin.com/in/borisdevloed/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile (opens in new window)"
          >
            {{t "experience.linkedin_link"}}
          </a>.
        </p>
      </div>
    </div>
  </section>

  {{! Education }}
  <section class="section section--alt" aria-labelledby="education-title">
    <div class="container">
      <h2 id="education-title">{{t "experience.education.title"}}</h2>

      <div class="timeline" role="list" aria-label="Education timeline">
        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="EducationalOccupationalCredential"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <time class="timeline__date" datetime="2009">2009</time>
          <h3 class="timeline__title" property="name">{{t
              "experience.education.msc.title"
            }}</h3>
          <div
            class="timeline__company"
            property="recognizedBy"
            typeof="EducationalOrganization"
          >
            <span property="name">{{t "experience.education.msc.school"}}</span>
          </div>
          <div class="timeline__description" property="description">
            <ul>
              <li>{{t "experience.education.msc.specialization"}}</li>
              <li>{{t "experience.education.msc.thesis"}}</li>
            </ul>
          </div>
        </article>

        <article
          class="timeline__item"
          role="listitem"
          vocab="https://schema.org/"
          typeof="EducationalOccupationalCredential"
        >
          <div class="timeline__marker" aria-hidden="true"></div>
          <time class="timeline__date" datetime="2008">2008</time>
          <h3 class="timeline__title" property="name">{{t
              "experience.education.bsc.title"
            }}</h3>
          <div
            class="timeline__company"
            property="recognizedBy"
            typeof="EducationalOrganization"
          >
            <span property="name">{{t "experience.education.bsc.school"}}</span>
          </div>
        </article>
      </div>
    </div>
  </section>

  {{! Languages }}
  <section class="section" aria-labelledby="languages-title">
    <div class="container">
      <h2 id="languages-title">{{t "experience.languages.title"}}</h2>
      <div class="services-grid">
        <div class="card card--bordered">
          <h3 class="card__title">{{t "experience.languages.dutch"}}</h3>
          <p class="card__description">{{t
              "experience.languages.dutch_level"
            }}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">{{t "experience.languages.english"}}</h3>
          <p class="card__description">{{t
              "experience.languages.english_level"
            }}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">{{t "experience.languages.french"}}</h3>
          <p class="card__description">{{t
              "experience.languages.french_level"
            }}</p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">{{t "experience.languages.spanish"}}</h3>
          <p class="card__description">{{t
              "experience.languages.spanish_level"
            }}</p>
        </div>
      </div>
    </div>
  </section>

  {{! Side Projects — Open Wine Map }}
  <section class="section section--alt" aria-labelledby="side-projects-title">
    <div class="container">
      <h2 id="side-projects-title">{{t "open_wine_map.section_title"}}</h2>

      <div class="card card--bordered">
        <h3 class="card__title">{{t "open_wine_map.title"}}</h3>
        <p class="card__description">
          {{t "open_wine_map.description"}}
        </p>
        <div class="mt-4">
          <a
            href="https://openwinemap.com"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn--outline"
            aria-label="Visit Open Wine Map (opens in new window)"
          >
            {{t "open_wine_map.cta"}}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
